import { Helmet } from "react-helmet"
import { useEffect } from "react"
import useViewportWidth from "../../hooks/useViewportWidth"

export default function MenuWithPictures({ setIsMenuOpen, setShowReservBtn }) {
    const viewportWidth = useViewportWidth()

    useEffect(() => {
        if (viewportWidth < 990) {
            setIsMenuOpen(false)
        }
        setShowReservBtn(true)
    }, [])
    const url = "https://drive.google.com/file/d/1gyPQbpGFcey_ZfmniKlnG13FzGve_7jb/preview"
    return (
        <div>
            <Helmet>
                <title>Képes Étlap / Menu with Pictures</title>
                <meta name="desription" content="Ételeink széles választéka képekkel" />
            </Helmet>
            <iframe src={url} title="menu_with_pictures" allow="autoplay"></iframe>
        </div>
    )
}